import { render, staticRenderFns } from "./accountsAppsGenerator.vue?vue&type=template&id=67c5be7b&"
import script from "./accountsAppsGenerator.vue?vue&type=script&lang=js&"
export * from "./accountsAppsGenerator.vue?vue&type=script&lang=js&"
import style0 from "./accountsAppsGenerator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports